import { useCurrentUser, useFeatureFlags } from "@common/hooks";
import { useMemo } from "react";

export const useDelegateEmployees = () => {
  const { isDelegateUsersEnabled } = useFeatureFlags();
  const { maybeCurrentUser } = useCurrentUser({
    skip: !isDelegateUsersEnabled,
  });

  const delegateEmployees = useMemo(() => {
    if (!maybeCurrentUser) {
      console.error("useDelegates: maybeCurrentUser is undefined");
      return [];
    } else if (!maybeCurrentUser.employee) {
      console.error("useDelegates: maybeCurrentUser.employee is undefined");
      return [];
    }

    return maybeCurrentUser.employee.delegateUsers.flatMap((u) =>
      u.employee
        ? [
            {
              firstName: u.firstName,
              lastName: u.lastName,
              workEmail: u.employee.workEmail,
              id: u.employee.employeeId,
              userId: u.userId,
            },
          ]
        : [],
    );
  }, [maybeCurrentUser]);

  const delegateHasTransactionAccess = useMemo(() => {
    if (!maybeCurrentUser) {
      console.error("useDelegates: maybeCurrentUser is undefined");
      return false;
    } else if (!maybeCurrentUser.cardholder) {
      console.error("useDelegates: maybeCurrentUser.cardholder is undefined");
      return false;
    }

    const value = maybeCurrentUser.cardholder.delegateHasTransactionAccess;
    return value ?? false;
  }, [maybeCurrentUser]);

  return { delegateEmployees, delegateHasTransactionAccess };
};
